import React, { useEffect } from 'react';

const Clarity = () => {
    useEffect(() => {
        // Insert Hotjar tracking code into the head section
        const script = document.createElement('script');
        script.innerHTML = `
             (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "o4mhw2vs4f");
        `;
        document.head.appendChild(script);

        return () => {
            // Cleanup if necessary
            document.head.removeChild(script);
        };
    }, []);

    return null;
};

export default Clarity;